/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import React from "react";
import FormFader from "../Common/Fader/FormFader";
import wizardStyle from "../wizardStyle";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import { useForm } from "../../../provider/Form/FormProvider";
import FormSubmitProps from "../../../types/FormSubmitProps";

import { Box } from "@mui/material";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import { requiredValidator } from "../../../services/validationRules";
import { translate } from "../../../services/translations/translations";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";

type InitialClientDescriptionAndObjectivesProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};

export default function InitialClientDescriptionAndObjectives({ submitProps, product }: InitialClientDescriptionAndObjectivesProps) {
  const { handleSubmit, values } = useForm();

  const isDisabled = (values.initialClientDescriptionAndObjectives?.length ?? 0) < 50;

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            {translate(`pendingCase.initialClientDescriptionAndObjectives.stepHeadline`, product)}
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid size={12}>
              <FormLegend>
                <strong>{translate(`pendingCase.initialClientDescriptionAndObjectives.stepHeadline`, product)}</strong>
              </FormLegend>
            </Grid>
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>{translate(`pendingCase.initialClientDescriptionAndObjectives.mainDescription`, product)}</FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorTextField
                name="initialClientDescriptionAndObjectives"
                label={translate(`pendingCase.initialClientDescriptionAndObjectives.label`, product)}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  maxLength: 5000,
                }}
                multiline
                rows={8}
                validators={[requiredValidator("Bitte beschreiben Sie was passiert ist und was Sie erreichen möchten.")]}
                helperText={
                  "[" +
                  (values.initialClientDescriptionAndObjectives?.length ?? 0) +
                  "/5000]" +
                  ((values.initialClientDescriptionAndObjectives?.length ?? 0) < 50 ? " Bitte geben Sie mindestens 50 Buchstaben ein" : "")
                }
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} disabled={isDisabled} />
        </Box>
      </FormFader>
    </Paper>
  );
}
